import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import { SimpleActionCreator, StatusSwitcherStore } from '../../helpers/types';

@Component({
  selector: 'app-status-switcher',
  templateUrl: './status-switcher.component.html',
  styles: ['.pointer { height: 100%; }']
})
export class StatusSwitcherComponent {
  @Input() action: SimpleActionCreator<{ id: string }>;
  @Input() eyeIcon: boolean;
  @Input() id: string;
  @Input() status: boolean;

  constructor(private store: Store<StatusSwitcherStore>) {}

  switchStatus(): void {
    this.store.dispatch(this.action({ id: this.id }));
  }
}
